// extracted by mini-css-extract-plugin
export var contrastLow = "_35-1";
export var externalLink = "_35-2";
export var externalLinkIcon = "_35-3";
export var link = "_35-0";
export var linkLabel = "_35-4";